/**
 *  Component: IconWithText
 */
import React from 'react';

import { StyledTypography } from 'styles/common';

const IconWithText = ({ icon, text }) => (
  <>
    {icon}
    <StyledTypography color="#333" topGutter={1} bottomGutter={5} rightGutter={5}>
      {text}
    </StyledTypography>
  </>
);

export default IconWithText;
